

































































































































































































































































































































































import { QnaQuestion } from '~/models/qna/types'
import CDropdownMenu from '~/components/shared/configurable/dropdown/CDropdownMenu.vue'
import CDropdownMenuItem from '~/components/shared/configurable/dropdown/CDropdownMenuItem.vue'
import { resolveCategory } from '~/utils/category'
import { debounce } from '~/utils/function'
import QnaMakeModelSelect from './QnaMakeModelSelect.vue'
import { CategoryId } from '~/models/category/types'
import { toCamelCase } from '~/utils/object'
import CRichTextEditor from '~/components/shared/configurable/form/rich-text/CRichTextEditor.vue'

import Bold from '@tiptap/extension-bold'
import Italic from '@tiptap/extension-italic'
import Underline from '@tiptap/extension-underline'
import Link from '@tiptap/extension-link'
import ListItem from '@tiptap/extension-list-item'
import BulletList from '@tiptap/extension-bullet-list'
import OrderedList from '@tiptap/extension-ordered-list'
import History from '@tiptap/extension-history'
import Placeholder from '@tiptap/extension-placeholder'
import { Category } from '~/models/search/types'
import { isArraysEquals } from '~/utils/array'
import { USER_NS } from '~/store/modules/shared/user/state'
import { mapGetters } from 'vuex'
import CClearButton from '~/components/shared/configurable/CClearButton.vue'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { categoriesIconsMappings } from '~/constants/category/icon'
import { DEBOUNCE_DEFAULT } from '~/constants/debounce'
import CFormError from '~/components/shared/configurable/form/CFormError.vue'
import { defineComponent, PropType } from '~/utils/nuxt3-migration'
import QnaPayAttention from '~/components/car/qna/QnaPayAttention.vue'
import CPanelCard from '~/components/shared/configurable/cpanel/CPanelCard.vue'

export default defineComponent({
  components: {
    CDropdownMenu,
    CDropdownMenuItem,
    QnaMakeModelSelect,
    CRichTextEditor,
    CClearButton,
    CFormError,
    QnaPayAttention,
    CPanelCard
  },
  props: {
    layoutType: {
      type: String as PropType<'search' | 'create'>,
      default: 'search'
    },
    categories: {
      type: Array as PropType<Array<{ label: string; value: number }>>,
      default: () => []
    },
    fuelTypes: {
      type: Array,
      default: () => []
    },
    tags: {
      type: Array,
      default: () => []
    },
    makeAndModels: { type: Array, default: () => [] },
    withoutLabels: { type: Boolean, default: false },
    topMakes: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    question: { type: Object as PropType<QnaQuestion>, default: () => {} },
    categoryId: { type: Number, default: null }
  },
  data() {
    return {
      modelsOptions: [],
      groupModelsOptions: [],
      makeOptions: [],
      tagOptions: [],
      selectedCategoryId: this.categoryId,
      dropdownSelectedCategory: null,
      // selectedQuestionType: QuestionCategoryType.CARS,
      selectedYear: null,
      yearOptions: [],
      fromYearOptions: [],
      toYearOptions: [],
      selectedTag: null,
      selectedMake: [],
      selectedModel: null,
      selectedFuel: null,
      fromYear: null,
      toYear: null,
      fuelOptions: [],
      questionTitle: '',
      questionTextJson: null,
      inputsState: {
        makeState: null,
        modelState: null,
        titleState: null,
        textState: null
      },
      showDeletedQuestions: false,
      isPayAttentionVisible: false
    }
  },
  computed: {
    ...mapGetters(USER_NS, {
      userIsAdmin: 'isAdmin'
    }),
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile',
      isPc: 'isPc'
    }),
    textEditorExtensions() {
      return [
        Bold,
        Italic,
        Underline,
        Link.configure({
          HTMLAttributes: {
            target: '_blank' // force target _blank because output will be viewed in iframe
          },
          openOnClick: false
        }),
        ListItem,
        BulletList,
        OrderedList,
        History,
        Placeholder.configure({
          placeholder: this.$i18n.t('write a question'),
          showOnlyWhenEditable: true
        })
      ]
    },
    categoryOptions() {
      if (this.layoutType === 'search') {
        if (this.isLayoutTypeCreate) {
          return this.createDefaultDropdownValue('category').concat(
            this.categories
          )
        }
        return this.createDefaultDropdownValue(
          null,
          this.$i18n.t('all::all_classifieds')
        ).concat(this.categories)
      }
      return this.categories
    },
    generateYears(): Array<{ id: number; name: number }> {
      const currentYear = new Date().getFullYear()
      const minYear = 1900
      return new Array(currentYear + 1 - minYear).fill(null).map((_, i) => {
        const year = currentYear - i
        return { id: year, name: year }
      })
    },
    isFuelTypesDisabled(): boolean {
      return (
        (this.isLayoutTypeCreate && !this.selectedCategoryId) ||
        !this.selectedCategoryId
      )
    },
    isTagsDisabled(): boolean {
      return this.isLayoutTypeCreate && !this.selectedCategoryId
    },
    hasLogo(): boolean {
      return CategoryId.CARS === this.selectedCategoryId
    },
    hasSelectedCategoryModels(): boolean {
      if (
        this.layoutType !== 'create' &&
        [CategoryId.CARS, CategoryId.BIKES].includes(this.selectedCategoryId)
      ) {
        return true
      }
      return (
        [CategoryId.CARS, CategoryId.BIKES].includes(this.selectedCategoryId) &&
        this.modelsOptions.length > 0
      )
    },
    isLayoutTypeCreate(): boolean {
      return this.layoutType === 'create'
    },
    isSelectedCategoryXymaOrPlot(): boolean {
      return [CategoryId.XYMA, CategoryId.PLOT].includes(
        this.selectedCategoryId
      )
    },
    icons() {
      return {
        warn: faExclamationTriangle
      }
    },
    isFuelTypeVisible() {
      return ![
        CategoryId.TRAILERS,
        CategoryId.SEMITRAILERS,
        CategoryId.TRAILER,
        CategoryId.AIRSPORTS
      ].includes(this.selectedCategoryId)
    }
  },
  watch: {
    fuelTypes() {
      this.fuelOptions = [this.fuelOptions[0]].concat(this.fuelTypes)
    },
    tags() {
      this.tagOptions = [this.tagOptions[0]].concat(this.tags)
    },
    makeAndModels() {
      if (this.selectedMake?.length) {
        this.setModels()
      }
    }
  },
  mounted() {
    this.$emit('mounted')
  },
  created() {
    this.setTagsData()
    this.setFuelTypeData()

    this.makeOptions = this.makeAndModels
    if (this.question?.id) {
      this.initData()
    }

    if (this.isLayoutTypeCreate) {
      this.yearOptions = this.createDefaultDropdownValue('registration').concat(
        this.generateYears
      )
    } else {
      const camelCaseQuery = toCamelCase(this.$router.currentRoute.query)
      this.setFieldValuesFromQueryParams(camelCaseQuery)
      const fromYear = camelCaseQuery.fromYear
        ? parseInt(camelCaseQuery.fromYear, 10)
        : null
      const toYear = camelCaseQuery.toYear
        ? parseInt(camelCaseQuery.toYear, 10)
        : null
      this.generateToYearOptions(fromYear)
      this.generateFromYearOptions(toYear)
    }
  },
  methods: {
    editorInput: debounce(function({ json, text }) {
      if (!text) {
        this.questionTextJson = null
        this.inputsState.textState = false
      } else {
        this.questionTextJson = json
        this.inputsState.textState = null
      }
    }, DEBOUNCE_DEFAULT),
    clearFilter(variable: string, value: any) {
      this[variable] = value
    },
    setTagsData() {
      this.tagOptions = this.createDefaultDropdownValue('tag').concat(this.tags)
    },
    setFuelTypeData() {
      this.fuelOptions = this.setOnSelectedInputData('fuel', this.fuelTypes)
    },
    handleFromYearChange(event: number, withoutEmit: boolean = false) {
      this.generateToYearOptions(event)
      if (!withoutEmit) {
        this.$emit('from-year-change', {
          value: event,
          field: 'fromYear'
        })
      }
    },
    handleToYearChange(event: number, withoutEmit: boolean = false) {
      this.generateFromYearOptions(event)
      if (!withoutEmit) {
        this.$emit('to-year-change', {
          value: event,
          field: 'toYear'
        })
      }
    },
    generateFromYearOptions(year: number) {
      const defaultVal = this.createDefaultDropdownValue(null, 'from')
      if (!year) {
        this.fromYearOptions = [].concat(defaultVal).concat(this.generateYears)
      } else {
        this.fromYearOptions = []
          .concat(defaultVal)
          .concat(this.generateYears.filter(y => y.id <= year))
      }
    },
    generateToYearOptions(year: number) {
      const defaultVal = this.createDefaultDropdownValue(null, 'to')
      if (!year) {
        this.toYearOptions = [].concat(defaultVal).concat(this.generateYears)
      } else {
        this.toYearOptions = []
          .concat(defaultVal)
          .concat(this.generateYears.filter(y => y.id >= year))
      }
    },
    setOnSelectedInputData(type: string, data: []) {
      let defaultValue = null
      if (this.isLayoutTypeCreate) {
        defaultValue = this.createDefaultDropdownValue(type)
      } else {
        defaultValue = this.createDefaultDropdownValue(
          null,
          this.$i18n.t('all')
        )
      }
      if (data?.length !== 0) {
        return defaultValue.concat(data)
      } else {
        return defaultValue
      }
    },

    handleMakeChange(
      makeIds: number | Array<number>,
      withEmit: boolean = true
    ) {
      const filteredMakeIds = [makeIds].flat().filter(m => !!m)
      if (this.selectedMake?.toString() !== filteredMakeIds.toString()) {
        // this.modelsOptions = []
        this.selectedMake = filteredMakeIds
        this.setModels()

        if (this.selectedMake.length) {
          this.inputsState.makeState = null
        }

        if (withEmit) {
          const categoryId = this.isLayoutTypeCreate
            ? this.selectedCategoryId
            : undefined
          this.$emit('make-change', {
            value: filteredMakeIds,
            field: 'make',
            categoryId
          })
        }
      }
    },
    handleModelChange(modelIds: [number] | number, withEmit: boolean = true) {
      const normalizedModelIds = [modelIds].flat() as [number]
      if (withEmit) {
        this.$emit('model-change', {
          value: normalizedModelIds,
          field: 'model'
        })
      }
      this.selectedModel = normalizedModelIds
    },
    handleCategoryChange(category: Category) {
      if (this.selectedCategoryId !== category?.id) {
        this.selectedCategoryId = category ? category.id : null
        this.selectedMake = null
        this.inputsState.makeState = null
        this.selectedTag = null
        this.clearMake()
        this.clearModel()
        if (this.isSelectedCategoryXymaOrPlot || !this.isFuelTypeVisible) {
          this.clearFields()
        }
        this.$emit('category-change', {
          categoryId: this.selectedCategoryId,
          ...category
        })
      }
    },
    createDefaultDropdownValue(
      name: string,
      prefix: string = 'choose'
    ): Array<{ id: number; name: string }> {
      // ${this.$i18n.t('choose')}
      return [
        {
          id: null,
          name: `${this.$i18n.t(prefix)} ${this.$i18n
            .t(name)
            .toString()
            .toLowerCase()}`
        }
      ]
    },

    getIcon(categoryIds) {
      return resolveCategory(categoriesIconsMappings, categoryIds)
    },
    handleDropdownCategoryChange(
      category: { id: number; name: string } | number
    ) {
      let categoryVal = category
      if (typeof category === 'number') {
        const { id, name } = this.getCategoryById(category)
        categoryVal = { id, name }
      }

      this.dropdownSelectedCategory = categoryVal
      this.handleCategoryChange(categoryVal)
    },
    isFormValid(): boolean {
      let validFields = 0
      let fieldsData = [
        { stateLabel: 'makeState', value: this.selectedMake },
        { stateLabel: 'titleState', value: this.questionTitle },
        { stateLabel: 'textState', value: this.questionTextJson }
      ]
      if (this.isSelectedCategoryXymaOrPlot) {
        fieldsData = fieldsData.filter(f => f.stateLabel !== 'makeState')
      }

      fieldsData.forEach(d => {
        if (
          !d.value ||
          (d.value !== 'string' &&
            Array.isArray(d.value) &&
            d.value.length === 0)
        ) {
          this.inputsState[d.stateLabel] = false
        } else {
          this.inputsState[d.stateLabel] = null
          validFields++
        }
      })
      return fieldsData.length === validFields
    },
    getFormData(): QnaQuestion {
      const data = {
        id: this.question ? this.question.id : null,
        year: this.selectedYear,
        tagId: this.selectedTag,
        makeId: this.selectedMake,
        modelId: this.selectedModel,
        fuelId: this.selectedFuel,
        categoryId: this.selectedCategoryId,
        title: this.questionTitle,
        text: this.questionTextJson
      }
      if (!data.id) {
        delete data.id
      }
      return data
    },
    getInvalidFields(): object {
      return this.inputsState
    },
    clearMake() {
      if (this.$refs?.makeSelect) {
        this.$refs.makeSelect.clearSelected()
      }
      this.selectedMake = []
    },
    clearModel() {
      if (this.$refs?.modelSelect) {
        this.$refs.modelSelect.clearSelected()
      }
      this.selectedModel = []
    },
    clearFields() {
      this.selectedYear = null
      this.selectedTag = null
      this.clearMake()
      this.clearModel()
      this.selectedFuel = null
    },
    setFieldValuesFromQueryParams({
      category,
      fromYear,
      fuelType,
      make,
      model,
      tag,
      toYear,
      deleted
    }) {
      this.selectedCategoryId = category ? parseInt(category, 10) : null
      this.setDropdownCategory()
      this.fromYear = parseInt(fromYear, 10) || null
      this.toYear = parseInt(toYear, 10) || null
      this.generateToYearOptions(this.fromYear)
      this.generateFromYearOptions(this.toYear)

      this.selectedTag = [tag].flat().map(() => parseInt(tag, 10)) || null

      if (Array.isArray(make)) {
        this.selectedMake = make.map(m => parseInt(m, 10))
      } else if (make) {
        this.selectedMake = [parseInt(make, 10)] || []
      } else if (!make) {
        this.selectedMake = []
      }
      if (
        make &&
        this.selectedMake &&
        !isArraysEquals([make].flat() as [string], this.selectedMake)
      ) {
        this.setModels()
      }
      this.selectedModel = model
        ? [model].flat().map(m => parseInt(m, 10))
        : null

      this.selectedFuel = parseInt(fuelType, 10) || null

      this.showDeletedQuestions = deleted === 'true'
    },
    checkInputValidity(inputName: string, e: string) {
      if (e.length) {
        this.inputsState[inputName] = null
      } else {
        this.inputsState[inputName] = false
      }
    },
    initData(question: QnaQuestion) {
      const questionData = question || this.question
      if (questionData) {
        if (questionData?.questionMake?.id) {
          this.handleMakeChange([questionData.questionMake.id], false)
        }
        if (questionData?.makemodel?.id) {
          this.handleModelChange(questionData.makemodel.id)
        }
        this.setDropdownCategory()
        this.questionTitle = questionData.questionTitle
        this.questionTextJson = questionData.questionTextJson
        this.selectedCategoryId = questionData.questionCategory.id
        this.selectedFuel =
          questionData.questionMetadata.find(qm => qm.key === 'fuel_type')
            ?.value || null
        this.selectedTag =
          questionData.questionMetadata.find(qm => qm.key === 'question_tag')
            ?.value || null
        this.selectedYear =
          questionData.questionMetadata.find(qm => qm.key === 'makemodel_year')
            ?.value || null

        this.showDeletedQuestions = questionData.deleted
      }
    },
    setModels(models: [] = null) {
      if (models) {
        if (this.selectedMake.length > 1) {
          this.groupModelsOptions = models
        } else {
          this.modelsOptions = models
        }
      } else {
        const makes = this.makeAndModels.filter(m =>
          this.selectedMake.includes(m.id)
        )
        const allModels = []
        if (this.selectedMake?.length > 1) {
          makes.forEach(m => {
            if (m?.models && this.selectedMake.includes(m.id)) {
              allModels.push({
                label: m.name,
                options: m?.models || []
              })
            }
          })
          this.groupModelsOptions = allModels // make?.models || []
          this.modelsOptions = []
        } else {
          const make = this.makeAndModels.find(
            m => m.id === this.selectedMake[0]
          )
          if (this.isMobile && !this.isLayoutTypeCreate) {
            this.modelsOptions = make?.models
              ? [{ text: make.name, options: make?.models }]
              : []
          } else {
            this.modelsOptions = make?.models || []
          }
          this.groupModelsOptions = []
        }
      }
    },
    setMakeAndModel(question: QnaQuestion) {
      //   this.selectedCategoryId = question.questionCategory
      this.selectedMake = [question.questionMake.id]
      this.selectedModel = question.makemodel.id
    },
    setDropdownCategory() {
      this.dropdownSelectedCategory = this.getCategoryById(
        this.selectedCategoryId
      )
    },
    getCategoryById(id: number): Category {
      return this.categories.find(c => c.id === id)
    }
  }
})
